module.exports = parcelRequire.resolve("7Bd9n");